import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics, isSupported } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

// Valida que la configuración de Firebase exista
if (!import.meta.env.VITE_FIREBASE_PROJECT_ID) {
  throw new Error("❌ Missing Firebase configuration. Check your .env (VITE_FIREBASE_...).");
}

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Inicializa la app de Firebase (evita doble inicialización en HMR)
const app: FirebaseApp = getApps().length ? getApps()[0]! : initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// Especificar la región es CRUCIAL para que httpsCallable funcione correctamente
const functions = getFunctions(app, 'us-central1');

// // Inicializa App Check (solo en cliente)
// // DESACTIVADO: Causa problemas de permisos si no está bien configurado en Google Cloud.
// if (typeof window !== 'undefined') {
//   // (window as any).self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
//   if (import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY) {
//     try {
//       initializeAppCheck(app, {
//         provider: new ReCaptchaV3Provider(import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY),
//         isTokenAutoRefreshEnabled: true,
//       });
//     } catch(e) {
//       console.error("Error initializing App Check", e);
//     }
//   }
// }

// Inicializa Analytics (solo en cliente si es soportado)
let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported && firebaseConfig.measurementId) {
      analytics = getAnalytics(app);
    }
  });
}

export { app, auth, db, storage, functions, analytics };
